<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Gysc3K/tc-custom/9781504093675.jpg?1731180728693" alt="This image is the cover for the book What Lies in the Dark"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What Lies in the Dark
      </h1>
      <p class="bookDescription body article font2">
        <b>Suspicion and paranoia engulf a community while a police detective hunts for a serial killer.</b><br/><br/> One murder can make a town nervous. Two brings fear. Add three, four, or even more, and neighbors will start to turn on one another . . .<br/><br/> Victoria Bullrush is a stickler for rules and tries to maintain a faultless investigation. But with each grisly killing, the urgency grows greater, and it soon becomes impossible to ignore the public’s growing anger . . .<br/><br/> Who is behind the killings? And why are they targeting this community?<br/><br/><i>What Lies in the Dark</i> is a breathtaking debut crime thriller.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        CM Thompson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2c3a4c3d